import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'jewish-star', 'IconJewishStar', [["path",{"d":"M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z","key":"svg-0"}]]);